import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { ChecklistReportStore } from 'stores/checklist-reports/checklist-report-store';
import { formatMetricRate, getMetricColor, METRIC_ORDER } from './checklist-metrics-cards';

interface ChecklistMetricsCardsMobileProps {
  checklistReportStore?: ChecklistReportStore;
}

const ChecklistMetricsCardsMobile: FC<ChecklistMetricsCardsMobileProps> = ({ checklistReportStore }) => {
  const { t } = useTranslation();
  const { metrics = [] } = checklistReportStore.state;

  const getMetric = (eventType: string): number => {
    const found = metrics.find(m => m.eventType === eventType);
    return found ? found.completionRate : 0;
  };

  return (
    <div className="grid grid-cols-2 gap-3 px-2 my-3">
      {METRIC_ORDER.map(eventType => {
        const rate = getMetric(eventType);
        return (
          <div key={eventType} className="text-white rounded-lg p-4 text-center" style={{ backgroundColor: getMetricColor(rate) }}>
            <div className="text-xs font-medium mb-1">{t(eventType)}</div>
            <div className="text-2xl font-bold">{formatMetricRate(rate)}</div>
          </div>
        );
      })}
    </div>
  );
};

export default connect(['checklistReportStore', ChecklistReportStore])(ChecklistMetricsCardsMobile);
